<ol class="breadcrumb">
    <breadcrumbs></breadcrumbs>
</ol>
<div class="container-fluid">
    <div class="row">
        <div class="col-sm-12">
            <wj-tab-panel [selectedIndex]="0">
                <wj-tab>
                    <a>{{ 'common.search' | transloco }}</a>
                    <div class="card">
                        <div class="card-header">
                            {{ 'common.search' | transloco }}
                        </div>
                        <div class="card-body">
                            <div class="row">
                                <div class="col-sm-12">
                                    <wj-flex-grid #newsGrid [isReadOnly]="true" [selectionMode]="'Row'" style="height:500px" [itemsSource]="newses">
                                        <wj-flex-grid-filter></wj-flex-grid-filter>
                                        <wj-flex-grid-column binding='newsDate' [header]="'admin.news_date_time' | transloco" [dataType]="'Date'" [format]="'yyyy/MM/dd HH:mm:ss'" [width]="150">
                                        </wj-flex-grid-column>
                                        <wj-flex-grid-column binding='public' [header]="'admin.publish' | transloco" [dataType]="'Boolean'" [width]="80">
                                        </wj-flex-grid-column>
                                        <wj-flex-grid-column binding='subject' [header]="'admin.subject' | transloco" [width]="200">
                                        </wj-flex-grid-column>
                                        <wj-flex-grid-column binding='content' [header]="'admin.content' | transloco" [width]="500">
                                            <ng-template wjFlexGridCellTemplate [cellType]="'Cell'"  let-item="item">
                                                <div [innerHtml]="sanitized.bypassSecurityTrustHtml(item.content)"></div>
                                            </ng-template>
                                        </wj-flex-grid-column>
                                    </wj-flex-grid>
                                </div>
                            </div>
                        </div>
                    </div>
                </wj-tab>
                <wj-tab>
                    <a>{{ 'admin.news' | transloco }}<span *ngIf="news['@rid'] == '#-1:-1'">({{ 'common.new' | transloco }})</span></a>
                    <div class="card">
                        <div class="card-header">
                            <div class="row">
                                <div class="col-md-2">
                                    <button (click)="createNew()" type="button" class="btn btn-block btn-primary">{{ 'admin.create_new' | transloco }}</button>
                                </div>
                                <div class="col-md-2">
                                    <button (click)="editNews()" type="button" class="btn btn-block btn-primary">{{ 'common.edit' | transloco }}</button>
                                </div>
                            </div>
                        </div>
                        <div class="card-body">
                            <div class="row">
                                <div class="col-sm-12">
                                    <div class="card">
                                        <div class="card-body">
                                            <fieldset [disabled]="mode == 'view'">
                                                <div class="form-group row">
                                                    <label class="col-md-6 form-control-label d-none d-lg-block">{{ 'admin.news_date_time' | transloco }}</label>
                                                    <div class="col-md-6">
                                                        <wj-input-date-time style="width:100%;" style="width:100%;" [(value)]="news.newsDate" [format]="'yyyy/MM/dd HH:mm:ss'" [isRequired]="true" [placeholder]="'admin.bid_date_time' | transloco"></wj-input-date-time>
                                                    </div>
                                                </div>
                                                <div class="form-group row">
                                                    <label class="col-md-6 form-control-label">{{ 'admin.publish' | transloco }}</label>
                                                    <div class="col-md-6">
                                                        <input type="checkbox" class="form-control" [(ngModel)]="news.public" [ngModelOptions]="{standalone: true}" [placeholder]="'admin.buyer' | transloco">
                                                    </div>
                                                </div>
                                                <div class="form-group row">
                                                    <label class="col-md-6 form-control-label d-none d-lg-block">{{ 'admin.subject' | transloco }}</label>
                                                    <div class="col-md-6">
                                                        <input type="text" class="form-control" [(ngModel)]="news.subject" [ngModelOptions]="{standalone: true}" [placeholder]="'admin.subject' | transloco">
                                                    </div>
                                                </div>
                                                <div class="form-group row">
                                                    <label class="col-md-6 form-control-label d-none d-lg-block">{{ 'admin.content' | transloco }}</label>
                                                </div>
                                                <div class="form-group row">
                                                    <div class="col-md-12" *ngIf="mode != 'view'">
                                                        <editor [(ngModel)]="news.content"  [ngModelOptions]="{standalone: true}" [init]="tinymceConfig"></editor>
                                                    </div>
                                                    <div class="col-md-12" *ngIf="mode == 'view'" [innerHtml]="sanitized.bypassSecurityTrustHtml(news.content)">
                                                    </div>
                                                </div>
                                            </fieldset>
                                        </div>
                                        <div *ngIf="mode == 'edit'" class="card-footer">
                                            <div class="row">
                                                <div class="col-md-6">
                                                    <button (click)="saveNews()" class="btn btn-primary btn-block">{{ 'common.save' | transloco }}</button>
                                                </div>
                                                <div class="col-md-6">
                                                    <button (click)="cancelNews()" class="btn btn-danger btn-block">{{ 'common.cancel' | transloco }}</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </wj-tab>
            </wj-tab-panel>
        </div>
    </div>
    <div class="row">
        <div class="col-sm-12">
            <div class="card">
                <div class="card-footer">
                    <div style="float:left; min-width: 150px;">
                        <wj-menu [(value)]="newses.pageSize" [header]="'admin.page_size' | transloco">
                            <wj-menu-item [value]="100">100</wj-menu-item>
                            <wj-menu-item [value]="500">500</wj-menu-item>
                            <wj-menu-item [value]="1000">1000</wj-menu-item>
                        </wj-menu>
                    </div>
                    <div style="float:left; min-width: 150px;">
                        <wj-collection-view-navigator [cv]="newses"></wj-collection-view-navigator>
                    </div>
                    <div style="float:left; min-width: 150px;">
                        <wj-collection-view-pager [cv]="newses"></wj-collection-view-pager>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

